<template>

    <div class="union-of-aries_splash">
        <div class="splash_top">
            <div class="bg-image">
                <div class="bg-image-left"></div>
                <div class="bg-image-right"></div>
            </div>
            <div class="splash_text">
                <img src="./assets/images/ceremony-3.png" />

                <router-link to="/rsvp" tag="button">RSVP</router-link>
            </div>
        </div>


        <div class="splash_ceremony">

            <div class="text-box">
                <!-- <h1>May 26 2018</h1> -->

                <h6>Ceremony</h6>
                <div class="text-deets">
                    <span>
                        May 26th,
                        4:30PM
                        <br /> 
                        <a href="https://www.google.com/maps/place/Urban+Artifact/@39.160679,-84.541999,15z/data=!4m5!3m4!1s0x0:0xe6e0c2cb367236e1!8m2!3d39.160679!4d-84.541999?sa=X&ved=0ahUKEwiztauno6vZAhUDWq0KHUbIDPEQ_BIIuQEwDA" target="_blank">urban artifact
                        </a>
                    </span>
                    <i>
                        urban artifact<br />
                        1660 Blue Rock St<br /> Cincinnati, OH 45223
                    </i>
                </div>

                <hr />

                <h6>Reception</h6>
                
                <div class="text-deets">
                    <span>May 26th, following the ceremony
                        <br /> 
                        <a href="https://www.google.com/maps/place/Urban+Artifact/@39.160679,-84.541999,15z/data=!4m5!3m4!1s0x0:0xe6e0c2cb367236e1!8m2!3d39.160679!4d-84.541999?sa=X&ved=0ahUKEwiztauno6vZAhUDWq0KHUbIDPEQ_BIIuQEwDA"
                    target="_blank">urban artifact
                        </a>
                    </span>
                </div>
            </div>
        </div>

        <Accomodations></Accomodations>
        <UnionOfAries></UnionOfAries>

        <div class="splash_footer">
            <img src="./assets/images/footer-2.jpg" />
        </div>


        <div class="splash_engagement">
            <h6>engagement Photos</h6>

            <span class="text-link"
            >engagement photos by our cousin at <a href="http://www.hannahelisabethphotography.com/" target="_blank">hannah elisabeth photography</a></span>

            <a class="image-link margin-top"
                href="https://www.facebook.com/aappiarius/media_set?set=a.10215630141932655.1073741847.1414470028&type=3&pnref=story"
                target="_blank">
                <img src="./assets/images/engagement-preview.jpg" />
            </a>
            <a class="image-link"
                href="https://www.facebook.com/aappiarius/media_set?set=a.10215630141932655.1073741847.1414470028&type=3&pnref=story"
                target="_blank">
                <img src="./assets/images/engagement-preview-2.jpg" />
            </a>
            <a class="image-link"
                href="https://www.facebook.com/aappiarius/media_set?set=a.10215630141932655.1073741847.1414470028&type=3&pnref=story"
                target="_blank">
                <img src="./assets/images/engagement-preview-3.jpg" />
            </a>
            <a class="image-link"
                href="https://www.facebook.com/aappiarius/media_set?set=a.10215630141932655.1073741847.1414470028&type=3&pnref=story"
                target="_blank">
                <img src="./assets/images/engagement-preview-4.jpg" />
            </a>

            <span class="text-link margin-top">
                view
                <a href="https://www.facebook.com/aappiarius/media_set?set=a.10215630141932655.1073741847.1414470028&type=3&pnref=story"
                target="_blank">
                        more photos on facebook &nbsp;&nbsp;&#8611;
                </a>
            </span>
        </div>

    </div>

</template>

<script>
import UnionOfAries from './UnionOfAries.vue'
import Accomodations from './Accomodations.vue'
export default {
  name: 'landing',
  components: {
      'UnionOfAries': UnionOfAries,
      'Accomodations': Accomodations,
  }
}
</script>




// WEBPACK FOOTER //
// src/Landing.vue